// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"pricing_wrapper__1icU8","container":"pricing_container__4677p","title":"pricing_title__ERiBr","description":"pricing_description__1w4Hz","btn":"pricing_btn__3566f"};